export const mapResponseToMainProduct = (data: any) => {
	return {
		productName: data.productName,
		description: data.description,
		imgUrl: data.imageUrl,
		url: data.url,
		productId: data.productId,
		quantity: data.quantity,
		divisionId: data.divisionId,
		divisionName: data.divisionName,
		groupId: data.groupId,
		groupName: data.groupName,
		subGroupId: data.subGroupId,
		subGroupName: data.subGroupName,
		manufacturer: data.manufacturer,
		manufacturerPartNumber: data.manufacturerPartNumber,
		stockStatus: data.stockStatus,
		navigationPath: data.navigationPath,
		isConfigBundle: data.isConfigBndle,
		insurance: data.insurance,
		insuranceProductId: data.productId,
		isFlexInsurance:
			data.singleFlexInsurance &&
			data.containsFlexInsurance &&
			data?.subscription?.isBoughtWithSubscription,
		subscription: data.subscription,
		price: data.price,
		priceNet: data.priceNet,
		promotionPrice: data.promotionPrice,
		countOfReviews: data.countOfReviews,
		averageRating: data.averageRating,
		cartId: data.cartId,
		cartItemId: data.cartItemId,
		selectedInsuranceId: data.insuranceId,
		configServices: data.configServices,
	};
};

export const mapResponseToSubscription = (data: any) => {
	return {
		subscription: data.subscription,
	};
};

export const mapResponseToRecommendedProducts = (data: any) => {
	return {
		productName: data.name,
		regionalProductSku: data.regionalProductSku,
		clickTrackingUrl: data.clickTrackingUrl,
		productDescription: data.description,
		productId: data.productId,
		imgUrl: data.imageUrl,
		previousPrice: data.previousPrice,
		price: data.price,
		priceValue: data.priceValue,
		priceNet: data.priceNet,
		promotionPrice: data.promotionPrice,
		url: data.url,
		sellerId: data.sellerId,
		sellerName: data.sellerName,
		stockStatus: data.stockStatus,
		manufacturer: data.brand,
		manufacturerPartNumber: data.manufacturerPartNumber,
		isConfigBundle: data.isConfigBndle,
		navigationPath: data.navigationPath,
		groupId: data.group,
		subGroupId: data.subGroup,
		divisionId: data.division,
		groupName: data.groupName,
		subGroupName: data.subGroupName,
		divisionName: data.divisionName,
		displayAsSubscriptionProduct: data.displayAsSubscriptionProduct,
		buyMessage: data.buyMessage,
		renewalPeriod: data.renewalPeriod,
		countOfReviews: data.countOfReviews,
		averageRating: data.averageRating,
	};
};

export const mapResponseToRecommendedGroups = (data: any) => {
	const groups = data.reduce((acc, curr, index) => {
		const currentGroup = [...curr.navigationPath.split("/")].pop();
		const groupIndex = acc?.findIndex(
			(group) => group.groupName === currentGroup,
		);

		if (groupIndex === -1) {
			acc.push({
				groupName: currentGroup,
				isActive: index === 0,
				items: [mapResponseToRecommendedProducts(curr)],
			});
		} else {
			acc[groupIndex].items.push(mapResponseToRecommendedProducts(curr));
		}
		return acc;
	}, []);

	return groups;
};

export const mapResponseToConfigServices = ({ data, selectedItem }) => {
	const selectedObjects = [];
	const group = data.groupedCartItems[0];

	group.items.forEach((prop) => {
		if (prop.id === selectedItem) {
			prop.configServices.forEach((selectedObject) => {
				selectedObjects.push({
					id: selectedObject.serviceProduct.productId,
					selected: selectedObject.serviceProduct.selected,
					options: selectedObject?.optionProducts?.filter(
						(option) => option.selected,
					),
				});
			});
		}
	});

	return selectedObjects;
};

export const mapSelectedConfigServices = (configServices, selected) => {
	const updatedConfigServices = configServices.map((object) => {
		const responseItem = selected.find((item) => item.id === object.id);
		if (responseItem) {
			return {
				...object,
				options: object?.options.map((option) => ({
					...option,
					selected: responseItem.options.some(
						(selectedOption) => selectedOption.productId === option.id,
					),
				})),
				selected: responseItem.selected,
			};
		}
		return object;
	});

	return updatedConfigServices;
};
